import PluginInputMask from "../plugins/input-mask";
import PluginScrollbar from "../plugins/scrollbar";
import PluginNoUiSlider from "../plugins/nouislider";

let Plugins = {};
Plugins.nouislider = PluginNoUiSlider;
Plugins.floatinglabel = require("./../plugins/floating-label");
Plugins.socialSharer = require("./../plugins/social-sharer");
Plugins.inputMask = PluginInputMask;
Plugins.scrollBar = PluginScrollbar;

export default Plugins;
